"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_i18next_1 = require("react-i18next");
var Menu_1 = require("../Menu");
var useOpponentWithMaxTime_1 = __importDefault(require("./useOpponentWithMaxTime"));
function EjectPlayerButton(props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var opponentWithNegativeTime = (0, useOpponentWithMaxTime_1.default)(0);
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ css: [Menu_1.menuButtonCss, buttonCss], disabled: !opponentWithNegativeTime }, props, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUserSlash }), t('Eject player')] })));
}
exports.default = EjectPlayerButton;
var buttonCss = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: darkred;\n  border-color: darkred;\n\n  &:focus, &:hover {\n    background: #ffd7d7;\n  }\n\n  &:active {\n    background: #ffbebe;\n  }\n\n  &:disabled {\n    color: #555555;\n    border-color: #555555;\n    background: transparent;\n    cursor: auto;\n  }\n"], ["\n  color: darkred;\n  border-color: darkred;\n\n  &:focus, &:hover {\n    background: #ffd7d7;\n  }\n\n  &:active {\n    background: #ffbebe;\n  }\n\n  &:disabled {\n    color: #555555;\n    border-color: #555555;\n    background: transparent;\n    cursor: auto;\n  }\n"])));
var templateObject_1;
